import { useMutation } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { ICompetency } from 'hooks/useGetAssessmentSteps';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

interface UpdateCompetencyOrderVariables {
  competencies: ICompetency[];
}

const useUpdateCompetencyOrder = (interviewUid: string) => {
  const {
    mutateAsync: updateCompetencyOrder,
    data,
    isLoading,
    error,
  } = useMutation<void, Error, UpdateCompetencyOrderVariables>(
    ['updateCompetencyOrder'],
    async ({ competencies }) => {
      const body = {
        interview: interviewUid,
        sequence: competencies.map((competency, index) => ({
          uid: competency.uid,
          order: index,
        })),
      };

      const response = await fetchWithCsrfToken<void>(
        `${PrependUrl.ASYNC}/competency/update_order`,
        'POST',
        body
      );

      return response;
    }
  );

  return {
    updateCompetencyOrder,
    data,
    isLoading,
    error,
  };
};

export default useUpdateCompetencyOrder;
